import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.4375rem;
`

export const ContainerHeader = styled.h1`
  color: ${themeGet('colors.black')};
  font-size: 1.125rem;
  font-family: ${themeGet('textFontFamilySemibold')};
  margin: 0.6875rem 0 0.6875rem;
`

export const SubscriptionContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 0.3125rem 0.6875rem 0.375rem;
  margin-bottom: 2.5rem;
  background-color: ${themeGet('colors.backgroundGray')};
  border: 1px solid ${themeGet('colors.borderDarkGray')};

  p {
    font-family: ${themeGet('textFontFamily')};
    font-size: 1rem;
    color: ${themeGet('colors.darkGray')};
    margin: 0;
    padding: 0;
  }
  p:first-child {
    margin-right: 2.5rem;
  }

  p:nth-child(2) {
    margin-right: 2.5rem;
  }

  p:nth-child(3) {
    margin-left: auto;
  }
`

export const MoveLicenseContainer = styled.div`
  display: flex;
  justify-content: center;

  input {
    height: 0.9375rem;
    width: 0.9375rem;
    border: 0.0938rem solid ${themeGet('colors.blue')};
    border-radius: 0.0625rem;
    cursor: pointer;
    outline: none;
    transition-duration: 0.3s;
  }

  span {
    padding: 0;
    margin: 0 0 0 0.5rem;
    line-height: 1;
  }
`



// WEBPACK FOOTER //
// ./src/components/EditLicensePrevSub/EditLicensePrevSub.styles.js